<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  watch:{
    '$store.getters.adminUserInfo':{
      handler(newVal){
        if(newVal!=null){
          this.initialize();
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods: {
    initialize() {
      this.getRoles();
      this.getGrades();
      this.getBranchSchools();
    },
    getRoles() {
      this.$store.dispatch("getRoles");
    },
    getGrades() {
      this.$store.dispatch("getGrades");
    },
    getBranchSchools() {
      this.$store.dispatch("getBranchSchools");
    },
  },
};
</script>
<style>
html,
body,
#app {
  margin: 0px;
  min-height: 100vh;
}
</style>